 import { useEffect, useRef } from "react";
 import { useLocation } from "@/lib/router-compat";
 
 /**
  * Scrolls to top on route change.
  * Prevents stale scroll positions when navigating between pages.
  */
 export const ScrollToTop = () => {
   const { pathname } = useLocation();
   const previousPathname = useRef(pathname);
 
   useEffect(() => {
     // Do not reset the initial document after hydration. On slower mobile
     // connections a visitor can already be scrolling the landing page before
     // this effect mounts; treating that mount as navigation sends them back to
     // the hero. Only reset after an actual client-side route change.
     if (previousPathname.current === pathname) return;
     previousPathname.current = pathname;
     window.scrollTo({ top: 0, left: 0, behavior: "instant" });
   }, [pathname]);
 
   return null;
 };